import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

Injectable();
export class ApiUrlInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this._shouldSetApiUrl(req.url)) {
      const url = `${
        environment.apiUrl.endsWith('/')
          ? environment.apiUrl
          : `${environment.apiUrl}/`
      }${req.url.startsWith('/') ? req.url.substring(1) : req.url}`;

      return next.handle(
        req.clone({
          url,
        })
      );
    }

    return next.handle(req);
  }

  private _shouldSetApiUrl(requestUrl: string): boolean {
    return (
      requestUrl.indexOf('http') !== 0 &&
      requestUrl.indexOf('/assets/fonts') !== 0 &&
      requestUrl.indexOf('/assets/icons') !== 0 &&
      requestUrl.indexOf('/assets/images') !== 0 &&
      requestUrl.indexOf('/assets/styles') !== 0 &&
      requestUrl.indexOf('/assets/i18n') !== 0 &&
      requestUrl.indexOf('assets/fonts') !== 0 &&
      requestUrl.indexOf('assets/icons') !== 0 &&
      requestUrl.indexOf('assets/images') !== 0 &&
      requestUrl.indexOf('assets/styles') !== 0 &&
      requestUrl.indexOf('assets/i18n') !== 0
    );
  }
}
